import { render, staticRenderFns } from "./DisplayCategory.vue?vue&type=template&id=5f1ffb63&scoped=true"
import script from "./DisplayCategory.vue?vue&type=script&lang=js"
export * from "./DisplayCategory.vue?vue&type=script&lang=js"
import style0 from "./DisplayCategory.vue?vue&type=style&index=0&id=5f1ffb63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1ffb63",
  null
  
)

export default component.exports